import React, { useState, useEffect, useRef } from 'react';
import './FreizeitMarkieren.css';
import '../Freizeit.css';
import { host_url } from '../../App'; // Import host_url
import Stadtplan_Bild from '../../assets/Stadtplan.jpg';
import Stadtplan_Marker from '../../assets/kreis.svg';
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import SuccessModal from '../../SuccessModal';

function FreizeitMarkieren() {
  const [angebote, setAngebote] = useState([]);
  const [selectedAngebot, setSelectedAngebot] = useState(null);
  const [coordinates, setCoordinates] = useState({ x: null, y: null });
  const [successMsg, setSuccessMsg] = useState('');
  const stadtplanRef = useRef(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paramId = params.get('angebotID');
    if (paramId) {
      setSelectedAngebot(paramId);
    }
  }, []);

  useEffect(() => {
    fetch(`${host_url}/freizeitangebote`)
      .then(response => response.json())
      .then(data => setAngebote(data));
  }, []);

  useEffect(() => {
    if (selectedAngebot) {
      fetch(`${host_url}/freizeitangebote?angebotid=${selectedAngebot}`)
        .then(response => response.json())
        .then(data => setCoordinates({ x: data.X, y: data.Y }));
    }
  }, [selectedAngebot]);

  const handleSelectChange = (event) => {
    setSelectedAngebot(event.target.value);
  };

  const handleMapClick = (event) => {
    const rect = stadtplanRef.current.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 1000;
    const y = ((event.clientY - rect.top) / rect.height) * 1000;
    setCoordinates({ x, y });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    fetch(`${host_url}/saveFreizeitCoordinates`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        angebotID: selectedAngebot, // Correct parameter name
        x: coordinates.x,
        y: coordinates.y,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setSuccessMsg('Koordinaten erfolgreich gespeichert!');
        } else {
          alert('Fehler beim Speichern der Koordinaten: ' + data.error);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        alert('Fehler beim Speichern der Koordinaten: ' + error.message);
      });
  };

  const getMarkerPosition = () => {
    if (!coordinates.x || !coordinates.y || !stadtplanRef.current) return { left: '0px', top: '0px' };
    const { offsetWidth: imgWidth, offsetHeight: imgHeight } = stadtplanRef.current;
    const left = (coordinates.x / 1000) * imgWidth;
    const top = (coordinates.y / 1000) * imgHeight;
    return { left: `${left}px`, top: `${top}px` };
  };

  return (
    <KernteamLayout>
    <div className="container freizeit-markieren-container">
      <BackArrow to="/freizeit" />
      <h1 className="section-title">Freizeitangebot auf Karte markieren</h1>
      <form onSubmit={handleSubmit}>
        <label htmlFor="dropdown">Freizeitangebot</label>
        <div className={`dropdown-wrapper ${selectedAngebot ? 'filled' : ''}`}>
          <select id="dropdown" value={selectedAngebot || ''} onChange={handleSelectChange}>
            <option value="" disabled>Wähle ein Freizeitangebot</option>
            {angebote.map(angebot => (
              <option key={angebot.ID} value={angebot.ID}>{angebot.Name}</option>
            ))}
          </select>
          <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
        </div>
        <input type="hidden" id="textfield1" name="textfield1" value={coordinates.x || ''} />
        <input type="hidden" id="textfield2" name="textfield2" value={coordinates.y || ''} />
          <button type="submit">Ort speichern</button>
      </form>
      <div className="logo-container" onClick={handleMapClick}>
        <img ref={stadtplanRef} src={Stadtplan_Bild} alt="Stadtplan" className="stadtplan" />
        {coordinates.x !== null && coordinates.y !== null && (
          <img
            src={Stadtplan_Marker}
            className="marker"
            style={getMarkerPosition()}
            alt={selectedAngebot ? selectedAngebot.Name : 'Marker'}
          />
        )}
      </div>
    </div>
    <SuccessModal message={successMsg} onClose={() => setSuccessMsg('')} />
    </KernteamLayout>
  );
}

export default FreizeitMarkieren;